/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortHistoryNameGet200ResponseRecordsInnerAllOfShip
 */
export interface PortHistoryNameGet200ResponseRecordsInnerAllOfShip {
    /**
     * IMO of ship
     * @type {number}
     * @memberof PortHistoryNameGet200ResponseRecordsInnerAllOfShip
     */
    imo?: number;
    /**
     * MMSI of ship
     * @type {number}
     * @memberof PortHistoryNameGet200ResponseRecordsInnerAllOfShip
     */
    mmsi?: number;
}

/**
 * Check if a given object implements the PortHistoryNameGet200ResponseRecordsInnerAllOfShip interface.
 */
export function instanceOfPortHistoryNameGet200ResponseRecordsInnerAllOfShip(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortHistoryNameGet200ResponseRecordsInnerAllOfShipFromJSON(json: any): PortHistoryNameGet200ResponseRecordsInnerAllOfShip {
    return PortHistoryNameGet200ResponseRecordsInnerAllOfShipFromJSONTyped(json, false);
}

export function PortHistoryNameGet200ResponseRecordsInnerAllOfShipFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortHistoryNameGet200ResponseRecordsInnerAllOfShip {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
    };
}

export function PortHistoryNameGet200ResponseRecordsInnerAllOfShipToJSON(value?: PortHistoryNameGet200ResponseRecordsInnerAllOfShip | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'imo': value.imo,
        'mmsi': value.mmsi,
    };
}

